import Accordion from "./Classes/Accordion";
import Swiper from "swiper";
import  {Navigation, Pagination, FreeMode, Autoplay} from "swiper/modules";
import "@lottiefiles/lottie-player";
import Cv from "./Classes/Cv"
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import TableIconReplacer from "./Classes/TableIconReplacer";
import Anchor from "./Classes/Anchor.js";
import ImageContainerResizer from "./Classes/imageContainerResizer";
import popupVideo from "./Classes/popupVideo";
// import CountUpNumbers from './Classes/CountUpNumbers';
import keyFigure from './Classes/keyfigure.js';
import Scrollspy from "./Classes/Scrollspy";
import Animation from "./Classes/Animation.js";
import LottieSwiper from "./Classes/LottieSwiper.js";
import AnimationStagger from "./Classes/AnimationStagger.js";

let imageContainerResizerInstance = null;


window.addEventListener("page_event_load", () => {
  new Cv();
  new Anchor();
  new TableIconReplacer();
  new keyFigure();
  new Scrollspy();
   new Animation();
  new popupVideo();
  new AnimationStagger();
   new LottieSwiper();


  new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });





  // const countUpInstance = new CountUpNumbers({
  //   numbersSelector: '.lc-keyfigure__number',
  //   classIn: 'is-in-viewport',
  //   classOut: 'is-not-in-viewport',
  //   langArray: ['de', 'en'],
  //   decimalArray: ['.', '.'],
  //   thousandSepArray: ['’', '’'],
  // });


  new Swiper('.swiper', {
    modules: [Navigation, Pagination, FreeMode],
   slidesPerView: "auto",
    spaceBetween: 10,
    loop: false,
     freeMode: {
      enabled: true,
      sticky: false,
      momentumBounce: false
    },
     breakpoints: {
    768: {
      spaceBetween: 24,
    }
    },
    watchOverflow: true,
    centeredSlides: false,



    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  new Swiper('.swiper-new.mySwiper', {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 300,
    loop: false,
    rewind: true,
    roundLengths: true,
    breakpoints: {
      768: {
        spaceBetween: 500,
      }
    },
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true,
    // },
    watchOverflow: true,
    centeredSlides: false,
    pagination: {
      el: ".lc-swiper-new .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.lc-swiper-new .lc-swiper-new__pagination .swiper-button-next',
      prevEl: '.lc-swiper-new .lc-swiper-new__pagination .swiper-button-prev',
    },
  });
  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});



window.addEventListener("page_event_load", () => {
    imageContainerResizerInstance = new ImageContainerResizer();
});

window.addEventListener("page_event_unloading", () => {
    if (imageContainerResizerInstance) {
        imageContainerResizerInstance.unsubscribe();
        imageContainerResizerInstance = null;
    }
});

window.addEventListener('note_event_load', evt => {
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});


window.addEventListener('note_unloaded', evt => {
  document.body.classList.remove("note-open");
});

export default {
  data() {
    return {
      sections: [],
      activeSection: null
    };
  },
  mounted() {
    // Initialize Scrollspy and update sections after the component is mounted
    this.scrollspy = new Scrollspy();
    this.scrollspy.init();  // Initialize and populate sections
    this.sections = this.scrollspy.sections;  // Bind sections to Vue data
  }
};
